const MIN_LIGHTNESS = 42;
const MAX_LIGHTNESS = 88;
const HUE = 220;
const SATURATION = 8;

export function weightBarColor(percentage: number, highestPercentage: number): string {
  const share = highestPercentage > 0 ? Math.min(percentage / highestPercentage, 1) : 0;
  return `hsl(${HUE}, ${SATURATION}%, ${MIN_LIGHTNESS + (MAX_LIGHTNESS - MIN_LIGHTNESS) * share}%)`;
}

export function weightBarWidth(percentage: number, highestPercentage: number): string {
  const share = highestPercentage > 0 ? Math.min(percentage / highestPercentage, 1) : 0;
  return `${Math.max(share * 100, 1.5)}%`;
}
